var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#0f172a",
    strokeWidth: 8,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.13 27.70 A44 44 0 0 1 113.89 73.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.57 101.65 A44 44 0 0 1 45.40 106.48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.31 80.64 A44 44 0 0 1 50.71 30.45"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0f172a"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "113.33,81.05 120.87,73.56 106.91,72.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.77,102.01 41.49,112.28 49.31,100.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.90,26.94 47.64,24.16 53.78,36.74"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 66,
    width: 7,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.5,
    y: 59,
    width: 7,
    height: 23,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 52,
    width: 7,
    height: 30,
    rx: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 26,
    r: 12,
    fill: "#f97316"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.1,
    cy: 92,
    r: 12,
    fill: "#2563eb"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.9,
    cy: 92,
    r: 12,
    fill: "#22c55e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeLogo);
export default __webpack_public_path__ + "static/media/office-logo.bd73db0879abe8d650dc9165bf94e396.svg";
export { ForwardRef as ReactComponent };